export const MULTI_DRIVER_FEATURES: ReadonlyArray<string> = [
  "ALO",
  "AOC",
  "CLO",
  "Luminaire info",
  "Startup time",
];

export const MULTI_DRIVER_MODAL_WINDOW_CLASS = "select-feature-modal";
export const MULTI_DRIVER_MODAL_BACKDROP_CLASS = "customBackdrop";
export const MULTI_DRIVER_MODAL_DELAY_MS = 9000;
